import { render, staticRenderFns } from "./PanelistSurveyCriterionPage.vue?vue&type=template&id=8abd237a"
import script from "./PanelistSurveyCriterionPage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyCriterionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports